import script from "./ComplaintsProcedure.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintsProcedure.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintsProcedure.vue?vue&type=style&index=0&id=5ec13812&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec13812"]])

export default __exports__